// import React, { useState } from "react";
// import "./versionHistory.scss";

// import Modal from "components/Models/index";

// import closeButton from "assets/images/fileImage/closeButton.svg";
// import profileImage from "assets/images/fileImage/profileImage.svg";
// import profileImage2 from "assets/images/fileImage/profileImage2.svg";
// import profileImage3 from "assets/images/fileImage/profileImage3.svg";
// import profileImage4 from "assets/images/fileImage/profileImage4.svg";
// import profileImage5 from "assets/images/fileImage/profileImage5.svg";
// import profileImage6 from "assets/images/fileImage/profileImage6.svg";
// import useScreenMobile from "hooks/useScreen";

// const userData = [
//   {
//     image: profileImage4,
//     name: "Vigneswaran Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage5,
//     name: "CIBI Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage6,
//     name: "Viswa Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage3,
//     name: "David Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage5,
//     name: "CIBI Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage6,
//     name: "Viswa Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage3,
//     name: "David Edited the file",
//     time: "3.30PM"
//   }
// ];

// const VersionHistory = () => {
//   const [showFileInfo, setShowFileInfo] = useState(false);
//   const isMobile = useScreenMobile({ size: 992 });

//   const toggleFileInfo = () => {
//     setShowFileInfo(!showFileInfo);
//   };

//   return (
//     <div className="modalBox" style={{ width: "100%", position: "relative" }}>
//       {isMobile ? (
//         <div className="hello" onClick={toggleFileInfo}>
//           hello
//         </div>
//       ) : (
//         ""
//       )}

//       {isMobile ? (
//         showFileInfo && (
//           <Modal showFooter={false} className="modal-bottom">
//             <div className="container versionHistoryContainer">
//               <div className="versionHeading">
//                 <h3>Version History</h3>
//                 <img
//                   src={closeButton}
//                   alt="closeButton"
//                   onClick={toggleFileInfo}
//                 />
//               </div>

//               <div className="historyAllDateDetails">
//                 <div className="todayHistory">
//                   <h3>Today (Mar 25, 2024)</h3>
//                   <div className="historyDetails">
//                     <div className="specificUserName">
//                       <div className="historyUserName">
//                         <img src={profileImage} alt="" />
//                         <p>Vigneswaran Edited the file</p>
//                       </div>
//                       <div className="historyTime">
//                         <p>3.30PM</p>
//                       </div>
//                     </div>
//                     <div className="subUserContent">
//                       <div className="specificUserName">
//                         <div className="historyUserName">
//                           <img src={profileImage2} alt="" />
//                           <p>You Shared the file</p>
//                         </div>
//                         <div className="historyTime">
//                           <p>6.30PM</p>
//                         </div>
//                       </div>
//                       <div className="specificUserName subUserSpecific">
//                         <div className="historyUserName">
//                           <img src={profileImage3} alt="" />
//                           <p>Sathish</p>
//                         </div>
//                         <div className="historyTime">
//                           <p>Editor</p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="todayHistory">
//                   <h3>Yesterday</h3>
//                   <div className="historyDetails">
//                     {userData?.map((item, index) => (
//                       <div key={index} className="specificUserName">
//                         <div className="historyUserName">
//                           <img src={item?.image} alt="" />
//                           <p>{item?.name}</p>
//                         </div>
//                         <div className="historyTime">
//                           <p>{item?.time}</p>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal>
//         )
//       ) : (
//         <Modal
//           showFooter={false}
//           className={`modal-bottom ${showFileInfo === true ? "active" : ""}`}
//         >
//           <div className="container versionHistoryContainer">
//             <div className="versionHeading">
//               <h3>Version History</h3>
//               <img
//                 src={closeButton}
//                 alt="closeButton"
//                 onClick={toggleFileInfo}
//               />
//             </div>

//             <div className="historyAllDateDetails">
//               <div className="todayHistory">
//                 <h3>Today (Mar 25, 2024)</h3>
//                 <div className="historyDetails">
//                   <div className="specificUserName">
//                     <div className="historyUserName">
//                       <img src={profileImage} alt="" />
//                       <p>Vigneswaran Edited the file</p>
//                     </div>
//                     <div className="historyTime">
//                       <p>3.30PM</p>
//                     </div>
//                   </div>
//                   <div className="subUserContent">
//                     <div className="specificUserName">
//                       <div className="historyUserName">
//                         <img src={profileImage2} alt="" />
//                         <p>You Shared the file</p>
//                       </div>
//                       <div className="historyTime">
//                         <p>6.30PM</p>
//                       </div>
//                     </div>
//                     <div className="specificUserName subUserSpecific">
//                       <div className="historyUserName">
//                         <img src={profileImage3} alt="" />
//                         <p>Sathish</p>
//                       </div>
//                       <div className="historyTime">
//                         <p>Editor</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="todayHistory">
//                 <h3>Yesterday</h3>
//                 <div className="historyDetails">
//                   {userData?.map((item, index) => (
//                     <div key={index} className="specificUserName">
//                       <div className="historyUserName">
//                         <img src={item?.image} alt="" />
//                         <p>{item?.name}</p>
//                       </div>
//                       <div className="historyTime">
//                         <p>{item?.time}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Modal>
//       )}
//     </div>
//   );
// };

// export default VersionHistory;

// import React from "react";
// import "./versionHistory.scss";

// import Modal from "components/Models/index";

// // import closeButton from "assets/images/fileImage/closeButton.svg";
// // import closeButtonDark from "assets/images/fileImage/closeButtonDark.svg";

// import profileImage from "assets/images/fileImage/profileImage.svg";
// import profileImage2 from "assets/images/fileImage/profileImage2.svg";
// import profileImage3 from "assets/images/fileImage/profileImage3.svg";
// import profileImage4 from "assets/images/fileImage/profileImage4.svg";
// import profileImage5 from "assets/images/fileImage/profileImage5.svg";
// import profileImage6 from "assets/images/fileImage/profileImage6.svg";
// import useScreenMobile from "hooks/useScreen";
// import Drawer from "components/Drawer/index";
// // import useTheme from "hooks/observer";

// const userData = [
//   {
//     image: profileImage4,
//     name: "Vigneswaran Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage5,
//     name: "CIBI Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage6,
//     name: "Viswa Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage3,
//     name: "David Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage5,
//     name: "CIBI Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage6,
//     name: "Viswa Edited the file",
//     time: "3.30PM"
//   },
//   {
//     image: profileImage3,
//     name: "David Edited the file",
//     time: "3.30PM"
//   }
// ];

// const VersionHistoryContent = ({ handleCancel }) => {
//   // const isMobile = useScreenMobile({ size: 992 });
//   // const theme = useTheme();
//   return (
//     <div className="container versionHistoryContainer">
//       {/* <div className="versionHeading">
//         <h3>Version History</h3>
//         <img
//           src={theme === "light" ? closeButton : closeButtonDark}
//           alt="closeButton"
//           onClick={handleCancel}
//           style={{ cursor: "pointer" }}
//         />
//       </div> */}

//       <div className="historyAllDateDetails">
//         <div className="todayHistory">
//           <h3>Today (Mar 25, 2024)</h3>
//           <div className="historyDetails">
//             <div className="specificUserName">
//               <div className="historyUserName">
//                 <img src={profileImage} alt="" />
//                 <p>Vigneswaran Edited the file</p>
//               </div>
//               <div className="historyTime">
//                 <p>3.30PM</p>
//               </div>
//             </div>
//             <div className="subUserContent">
//               <div className="specificUserName">
//                 <div className="historyUserName">
//                   <img src={profileImage2} alt="" />
//                   <p>You Shared the file</p>
//                 </div>
//                 <div className="historyTime">
//                   <p>6.30PM</p>
//                 </div>
//               </div>
//               <div className="specificUserName subUserSpecific">
//                 <div className="historyUserName">
//                   <img src={profileImage3} alt="" />
//                   <p>Sathish</p>
//                 </div>
//                 <div className="historyTime">
//                   <p>Editor</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="todayHistory">
//           <h3>Yesterday</h3>
//           <div className="historyDetails">
//             {userData?.map((item, index) => (
//               <div key={index} className="specificUserName">
//                 <div className="historyUserName">
//                   <img src={item?.image} alt="" />
//                   <p>{item?.name}</p>
//                 </div>
//                 <div className="historyTime">
//                   <p>{item?.time}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const VersionHistory = ({ isVisible, handleCancel ,currentPath}) => {
//   console.log("currentPath-------------->", currentPath);
//   const isMobile = useScreenMobile({ size: 992 });
//   return isMobile ? (
//     <Drawer
//       isVisible={isVisible}
//       showFooter={false}
//       handleCancel={handleCancel}
//       heading="Version History"
//     >
//       <VersionHistoryContent handleCancel={handleCancel} />
//     </Drawer>
//   ) : (
//     <Modal
//       showFooter={false}
//       handleCancel={handleCancel}
//       heading="Version History"
//     >
//       <VersionHistoryContent handleCancel={handleCancel} />
//     </Modal>
//   );
// };

// export default VersionHistory;





import React, { useEffect, useState } from "react";
import "./versionHistory.scss";

import Modal from "components/Models/index";
import Drawer from "components/Drawer/index";
import Button from "components/Button/index";
import useScreenMobile from "hooks/useScreen";
import { Item } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import ListIcons from "constants/Homepage/ysafe/menuList/listIconsFunc";

const VersionHistoryContent = ({ handleCancel, currentPath, selectedRow }) => {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingVersion, setDeletingVersion] = useState(null);
  const showtoast = useToast();
  // Version delete: visible for every user (Individual, SuperAdmin) except when an organisation user
  // (Employee) is viewing a file that the Organisation shared with them — then hide delete.
  const isSharedContext =
    Array.isArray(currentPath) &&
    (currentPath[0] === "shared" || currentPath[0] === "external_shared");
  const usertype = sessionStorage.getItem("usertype");
  // Restore and Delete version: hidden for any shared context (Internal Share or External Spaces)
  const canDeleteVersion = !isSharedContext;
  const canRestoreVersion = !isSharedContext;
  // Fetch versions from WASM
  useEffect(() => {
    const fetchVersions = async () => {
      try {
        // await init();
        // console.log("flow in list versions");
        // console.log("Curernt path",currentPath.length);
        let dupCurrentPath = currentPath;
        if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
          const newPath = [...dupCurrentPath];
          newPath.splice(1, 1);
          dupCurrentPath = newPath;
        }
        let fileName = selectedRow.name;
        if (dupCurrentPath.length === 1 && dupCurrentPath[0] == "shared") {
          fileName = selectedRow.uuids;
        }

        // TODO: REMOVE this hardcoding shit and write proper methods like a singleton class
        if (dupCurrentPath.length == 1 && dupCurrentPath[0] == "external_shared") {
          fileName = selectedRow.uuids;
        }


        // console.log("Curernt path after",dupCurrentPath);
        const formattedPath =
          dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;


        const fullPath = `${formattedPath}/${fileName}`;
        const fo = await Item.getItem(fullPath);
        //  TODO:this below line that sets filename,is it needed?this is problematic
        fo.setFileName(fileName);
        const versionList = await fo.listVersions(); // assuming this returns an array of versions
        const versions = versionList.versions;
        const sizes = versionList.sizes;

        const createdDates = versionList.creationDates;

        const currentVersion = versionList.currentVersion;

        // Convert UTC date string to local time (same as used in list view)
        const convertUTCToLocal = (dateString) => {
          if (!dateString) return "";

          const isoUTC = dateString.replace(" ", "T") + "Z";

          const d = new Date(isoUTC);
          if (isNaN(d.getTime())) return dateString;

          // Format using the user's current locale + timezone
          const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          };

          // Example output: "2025-11-27 18:42:10"
          const formatted = d.toLocaleString(undefined, options);

          // Standardize separators
          return formatted.replace(",", "");
        };

        const formattedVersions = versions.map((version, index) => ({
          versionName: version,
          size: sizes[index],
          createdDate: convertUTCToLocal(createdDates[index]),
          createdDateRaw: createdDates[index], // Keep original for sorting
          isCurrent: version === currentVersion
        }));

        // Sort versions by time (newest first)
        const sortedVersions = formattedVersions.sort((a, b) => {
          // Parse the date strings to Date objects for comparison
          const dateA = a.createdDateRaw ? new Date(a.createdDateRaw.replace(" ", "T") + "Z") : new Date(0);
          const dateB = b.createdDateRaw ? new Date(b.createdDateRaw.replace(" ", "T") + "Z") : new Date(0);
          return dateB.getTime() - dateA.getTime(); // Descending order (newest first)
        });

        setVersions(sortedVersions);
      } catch (error) {
        console.error("Failed to load versions:", error);
        setVersions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVersions();
  }, []);

  const handleRestore = async (version) => {

    // TODO: Add restore logic
    try {
      // await init();
      let fileName = selectedRow.name;
      let dupCurrentPath = currentPath;
      if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }
      if (dupCurrentPath.length === 1 && dupCurrentPath[0] == "shared") {
        fileName = selectedRow.uuids;
      }

      // console.log("Current path",dupCurrentPath);
      const formattedPath =
        dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;
      const fullPath = `${formattedPath}/${fileName}`;
      // console.log("Full path",fullPath);
      const item = await Item.getItem(fullPath);

      item.setFileName(fileName);
      // console.log("Item",item);
      await item.resetVersion(version); // assuming this method exists

      showtoast("Version restored successfully", "success");
    } catch (error) {
      showtoast("Failed to restore version", "error");
      console.error("Failed to restore version:", error);
    }
    handleCancel(); // Close the modal after restoring
    // Optionally, you can refresh the versions list after restoring
    setVersions((prevVersions) => prevVersions.filter(v => v.versionName !== version));
  };

  /**
   * Delete a non-current file version.
   * BACKEND INTEGRATION: When the backend supports delete-version (e.g. SDK item.deleteVersion(versionId)
   * or a dedicated API), call it here after building fullPath. On success, run the setVersions + success
   * toast below. Remove or adjust the "deleteVersion is not a function" guard once the backend is wired.
   * @param {string} versionName - Version ID (hex string) of the version to delete.
   */
  const handleDeleteVersion = async (versionName) => {
    if (!versionName) return;
    if (!canDeleteVersion) {
      showtoast("You don't have permission to delete versions.", "error");
      return;
    }
    setDeletingVersion(versionName);
    try {
      const fileName = selectedRow.name;
      const formattedPath = currentPath?.length === 0 ? "" : `/${currentPath?.join("/")}`;
      const fullPath = `${formattedPath}/${fileName}`;
      const item = await Item.getItem(fullPath);
      item.setFileName(fileName);

      await item.removeVersion(versionName);

      setVersions((prev) => prev.filter((v) => v.versionName !== versionName));
      showtoast("Version deleted successfully", "success");
    } catch (error) {
      showtoast(error?.message || "Failed to delete version", "error");
      console.error("Failed to delete version:", error);
    } finally {
      setDeletingVersion(null);
    }
  };


  return (
    <div className="version-history-container">
      {loading ? (
        <p>Loading versions...</p>
      ) : versions.length === 0 ? (
        <p>No versions found.</p>
      ) : (
        <div className="version-table-wrapper">
          <table className="version-table">
            <thead>
              <tr>
                <th>Version Name</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {versions.map((version, index) => (
                <tr key={index}>
                  <td>{version.createdDate || `Version ${index + 1}`}</td>
                  <td>{version.size}</td>

                  <td>
                    {version.isCurrent ? (
                      <span className="current-version-label">Current Version</span>
                    ) : (
                      <div className="version-actions">
                        {canRestoreVersion && (
                          <Button
                            title="Restore"
                            onClick={() => handleRestore(version.versionName)}
                            type="violet"
                            width="100px"
                          />
                        )}
                        {canDeleteVersion && (
                          <button
                            type="button"
                            className="version-delete-icon"
                            title={deletingVersion === version.versionName ? "Deleting..." : "Delete"}
                            aria-label="Delete version"
                            onClick={() => handleDeleteVersion(version.versionName)}
                            disabled={!!deletingVersion}
                          >
                            <ListIcons type="trash" />
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

};

const VersionHistory = ({
  isVisible,
  handleCancel,
  currentPath,
  selectedRow,
  centered
}) => {
  const isMobile = useScreenMobile({ size: 992 });

  return isMobile && !centered ? (
    <Drawer
      isVisible={isVisible}
      showFooter={false}
      handleCancel={handleCancel}
      heading="Versions"
    >
      <VersionHistoryContent
        handleCancel={handleCancel}
        currentPath={currentPath}
        selectedRow={selectedRow}
      />
    </Drawer>
  ) : (
    <Modal
      showFooter={false}
      handleCancel={handleCancel}
      heading="Versions"
    >
      <VersionHistoryContent
        handleCancel={handleCancel}
        currentPath={currentPath}
        selectedRow={selectedRow} />
    </Modal>
  );
};

export default VersionHistory;

